export const RIBBONS_SVG = [
  {
    id: "ribbon1",
    viewBox: "0 0 400 400",
    selectedpalate: 0,
    data: [
      {
        fill: "#AA3835",
        id: "ribbon1-1",
        d: `M400,167c0-20.6-99-0.4-169.9-23.2c-80.6-26-161.3-67.3-161.3-90.4c0,0,0,40.2,0,58.1s91.8,51.9,113,59.4
       C269.9,202.1,400,223.3,400,167z M0,233.1c0,27,103.7,2.8,175.5,27c81.5,27.5,154.6,72,154.6,88c0,0,0-40.7,0-58.1
       c0-12.1-16.9-24.3-42.7-33.1c-17.2-2-36.2-6.4-57.4-13.9C142,211.8,0,159.6,0,233.1z`,
      },
      {
        fill: "#CD473B",
        id: "ribbon1-2",
        d: `M304.8,111.9l32-29.1c-27.5,1.7-82-2-127.3-17.3C144.3,43.6,68.9,30.1,68.9,53.4v58.1c0-22.7,61.7-8.7,116.2,5
       l0,0c7.9,2,16.1,4.4,24.3,7.1c45.3,15.3,99.9,18.9,127.3,17.3L304.8,111.9z M0,167v66.1c0-46.7,142-21.3,230.1,9.9
       c21.2,7.5,40.2,11.9,57.4,13.9c54.2,6.4,112.5-5.8,112.5-23.8V167c0,22.7-81.9,41.2-169.9,9.9C142,145.7,0,119.1,0,167z M94.2,289.5
       l-32,29.1c27.5-1.7,82,2,127.3,17.3c65.1,22,140.5,32,140.5,12.2V290c0,20.5-61.6,8.7-116.2-5l0,0c-7.9-2-16.1-4.4-24.3-7.1
       c-45.3-15.3-99.9-18.9-127.3-17.3L94.2,289.5z`,
      },
    ],
    palette: [
      ["#AA3835", "#CD473B"],
      ["#3498DB", "#2ECC71"],
      ["#8E44AD", "#1ABC9C"],
      ["#D35400", "#2C3E50"],
    ],
  },
  {
    id: "ribbon2",
    viewBox: "0 0 400 200",
    selectedpalate: 0,
    data: [
      {
        fill: "#F3E683",
        id: "ribbon2-1",
        d: `M101.3,133.2c-13.7-1.1-45.4-5.2-75,37.2c0,0,2.3-33.2,10.6-39.6L0,135.2c31.4-32.9,60.2-36.9,60.2-36.9
             l1.8,11.2c0.2,1.1,0.5,2.1,0.9,3.1l0,0c0.4,1,0.9,1.9,1.6,2.7c3.1,4,9.6,10.5,18.6,8.9c12.9-2.3,42.1-33.3,54.6-17
             c0.4,0.5,0.8,1.1,1.1,1.6C145.7,121,127.8,135.2,101.3,133.2z M373.7,170.3c-29.6-42.4-61.3-38.2-75-37.2
             c-26.5,2-44.4-12.1-37.4-24.3l0.2-0.4c0.3-0.4,0.6-0.8,0.9-1.3c12.6-16.3,41.7,14.7,54.6,17c9,1.6,15.5-4.8,18.6-8.9
             c0.7-0.8,1.2-1.7,1.6-2.7s0.7-2.1,0.9-3.2l1.8-11.2c0,0,28.8,4.1,60.2,36.9l-36.9-4.4C371.4,137.1,373.7,170.3,373.7,170.3z`,
      },
      {
        fill: "#FFFCEE",
        id: "ribbon2-2",
        d: `M138.7,108.8c-0.2,2.7-1.5,5.3-3.3,7.4s-4,3.8-6.3,5.2c-4.7,2.8-10.1,4.4-15.5,5.3s-11,0.9-16.4,0.4
             c-5.4-0.4-10.8-0.4-16.2,0.2l-2,0.2c-0.7,0.1-1.3,0.2-2,0.3c-1.3,0.2-2.7,0.4-4,0.8c-1.3,0.3-2.6,0.6-3.9,1l-3.8,1.2
             c-1.3,0.4-2.5,1-3.8,1.5l-1.9,0.8l-1.8,0.9c-1.2,0.6-2.4,1.2-3.6,1.9l-3.4,2.2c-9.1,5.9-16.8,13.8-23.5,22.4
             c6.4-8.8,13.9-17,23-23.1l3.4-2.3c1.2-0.7,2.4-1.3,3.6-2l1.8-1l1.9-0.8c1.3-0.5,2.5-1.2,3.8-1.6c5.1-2,10.6-3.2,16.1-3.7
             s11-0.3,16.4,0.3c5.4,0.6,10.8,0.7,16.2-0.1c5.4-0.8,10.7-2.3,15.4-4.9c2.4-1.3,4.6-3,6.4-5C137.1,114,138.5,111.5,138.7,108.8z
              M128.3,89c-0.4,2.8-2,5.2-3.9,7.1c-2,1.9-4.4,3.4-6.8,4.6c-5,2.4-10.5,3.7-15.9,4.3c-5.5,0.6-11.1,0.4-16.5-0.2
             c-5.5-0.5-10.9-0.7-16.4-0.4c-10.9,0.6-21.6,3.4-31.2,8.7c-2.5,1.2-4.7,2.8-7,4.2c-1.2,0.7-2.2,1.6-3.3,2.4l-3.3,2.5
             c-2.1,1.8-4.1,3.6-6.2,5.5l-5.7,5.9l5.6-6.1c2-1.9,4-3.8,6-5.7l3.2-2.6c1.1-0.8,2.1-1.8,3.3-2.5c2.3-1.5,4.5-3.2,7-4.5
             c9.6-5.5,20.5-9,31.6-9.4c5.6-0.3,11.1,0.2,16.6,0.9c5.4,0.8,10.9,1,16.4,0.6c5.4-0.5,10.9-1.6,15.9-3.9c2.5-1.1,4.9-2.6,6.9-4.4
             C126.3,94.1,127.9,91.7,128.3,89z M260.9,109.5c0.3,2.7,1.7,5.2,3.5,7.2s4.1,3.6,6.4,4.9c4.8,2.6,10.1,4.1,15.5,4.8
             c2.7,0.3,5.4,0.5,8.1,0.5s5.4-0.3,8.1-0.5s5.5-0.4,8.3-0.4s5.5,0.2,8.3,0.5c5.5,0.7,10.9,2,16,4s10,4.6,14.6,7.8
             c4.5,3.1,8.7,6.7,12.6,10.6c3.8,3.9,7.3,8.2,10.6,12.6c-6.7-8.6-14.5-16.5-23.6-22.6c-4.5-3-9.4-5.5-14.5-7.4s-10.4-3.1-15.8-3.6
             c-5.4-0.6-10.8-0.5-16.3-0.2c-5.4,0.5-11.1,0.5-16.5-0.4s-10.8-2.5-15.6-5.3c-2.4-1.4-4.6-3.1-6.4-5.2
             C262.4,114.9,261.1,112.3,260.9,109.5z M274.1,88.8c0.4,2.7,2,5.1,3.9,7c2,1.9,4.3,3.3,6.7,4.5c4.9,2.3,10.3,3.4,15.7,3.9
             c2.7,0.2,5.4,0.2,8.1,0.1s5.4-0.5,8.1-0.9c2.7-0.3,5.5-0.6,8.2-0.8c2.8-0.1,5.5-0.1,8.3,0.1c5.5,0.4,11,1.4,16.2,3.1
             c2.6,0.9,5.2,1.8,7.7,3c1.3,0.5,2.5,1.2,3.7,1.8c1.2,0.7,2.4,1.3,3.6,2c4.7,2.8,9.1,6.1,13.2,9.8c4.1,3.7,7.8,7.7,11.3,11.9
             c-7.2-8.2-15.5-15.6-24.9-21c-1.2-0.7-2.4-1.3-3.6-1.9s-2.4-1.2-3.7-1.7c-2.5-1.1-5.1-2-7.6-2.8c-5.2-1.6-10.6-2.5-16-2.7
             c-5.4-0.3-10.8,0-16.3,0.6c-5.4,0.7-11,1-16.5,0.4s-10.9-1.9-15.9-4.3c-2.5-1.2-4.8-2.8-6.7-4.8C275.9,94,274.4,91.5,274.1,88.8z`,
      },
      {
        fill: "#D8C670",
        id: "ribbon2-3",
        d: `M337.1,112.6c-0.4,1-0.9,1.9-1.6,2.7c-3.1,4-9.6,10.5-18.6,8.9c-12.9-2.3-42.1-33.3-54.6-17
             c-0.3,0.4-0.6,0.8-0.9,1.3l15.3-26.9C313.9,90,335.9,102.2,337.1,112.6z M138.8,108.8c-0.3-0.6-0.7-1.1-1.1-1.6
             c-12.5-16.3-41.7,14.7-54.6,17c-9.1,1.6-15.5-4.8-18.6-8.9c-0.6-0.8-1.2-1.7-1.6-2.7l0,0c1.2-10.4,23.2-22.6,60.4-31L138.8,108.8z`,
      },
      {
        fill: "#F8EF99",
        id: "ribbon2-4",
        d: `M343.9,71.7l-4.2,26.5l-1.8,11.2c-0.2,1.1-0.5,2.2-0.9,3.2c-1.2-10.4-23.2-22.6-60.4-31.1
             c-3.6-0.8-7.3-1.6-11.2-2.4c-43.3-8.3-87.8-8.3-131.1,0c-3.9,0.7-7.6,1.5-11.2,2.4c-37.1,8.5-59.2,20.6-60.4,31
             c-0.4-1-0.7-2.1-0.9-3.1L60,98.2l-4.2-26.5c0.7-9.9,26.8-24.4,70.2-34c48.5-10.8,98.9-10.8,147.5,0
             C317.1,47.4,343.3,61.8,343.9,71.7z`,
      },
      {
        fill: "#FFFCEE",
        id: "ribbon2-5",
        d: `M338.9,103.9c-0.2-1.5-0.9-3-1.7-4.3c-0.8-1.3-1.9-2.5-3-3.5c-2.2-2.1-4.8-3.9-7.4-5.5
             c-5.3-3.2-11-5.7-16.8-7.9c-11.6-4.4-23.7-7.6-35.8-10.1c-12.2-2.5-24.5-4.4-36.8-5.7C225,65.6,212.6,65,200.2,65
             s-24.8,0.6-37.2,1.9c-12.4,1.2-24.7,3.1-36.8,5.7C114,75,102,78.2,90.3,82.6c-5.8,2.2-11.5,4.6-16.9,7.8c-2.7,1.6-5.2,3.4-7.5,5.5
             c-1.1,1.1-2.2,2.2-3,3.5s-1.5,2.7-1.7,4.3c0.2-1.6,0.7-3,1.5-4.4c0.8-1.3,1.8-2.6,2.9-3.7c2.2-2.2,4.7-4.2,7.4-5.9
             c5.3-3.4,11-6.1,16.8-8.5c5.8-2.4,11.8-4.3,17.7-6.1c6-1.8,12.1-3.4,18.2-4.7c24.4-5.6,49.5-8.2,74.5-8.3c25,0.1,50.1,2.7,74.5,8.4
             c6.1,1.3,12.2,2.9,18.2,4.7c6,1.8,11.9,3.8,17.7,6.2c5.8,2.4,11.4,5.2,16.7,8.6c2.6,1.7,5.1,3.6,7.3,5.9c1.1,1.1,2.1,2.4,2.9,3.7
             C338.1,100.8,338.7,102.3,338.9,103.9z M342.7,78.6c-0.2-1.6-0.9-3.1-1.8-4.4s-1.9-2.5-3.1-3.6c-2.3-2.2-4.9-4.1-7.6-5.7
             c-5.5-3.3-11.3-5.9-17.3-8.1c-11.9-4.5-24.3-7.8-36.8-10.4c-12.5-2.6-25.1-4.6-37.8-5.9c-12.7-1.3-25.5-2-38.2-2
             c-12.8,0-25.5,0.7-38.2,2s-25.3,3.2-37.9,5.8c-12.5,2.5-24.9,5.8-36.9,10.2c-6,2.2-11.9,4.8-17.3,8c-2.7,1.6-5.3,3.5-7.7,5.7
             c-1.2,1.1-2.2,2.3-3.1,3.6c-0.9,1.3-1.5,2.8-1.8,4.4c0.2-1.6,0.8-3.1,1.6-4.5s1.8-2.7,3-3.8c2.3-2.3,4.9-4.3,7.6-6
             c5.4-3.5,11.3-6.3,17.2-8.7c6-2.4,12.1-4.5,18.2-6.3c3.1-0.9,6.2-1.8,9.3-2.6c3.1-0.8,6.2-1.6,9.4-2.2c25.1-5.7,50.8-8.4,76.6-8.5
             c25.7,0.1,51.5,2.8,76.5,8.6c6.3,1.4,12.5,3,18.7,4.8s12.3,3.9,18.2,6.4c5.9,2.5,11.8,5.3,17.2,8.8c2.7,1.8,5.3,3.7,7.5,6
             c1.1,1.2,2.1,2.4,3,3.8C342,75.4,342.6,77,342.7,78.6z`,
      },
    ],
    palette: [
      ["#F3E683", "#FFFCEE", "#D8C670", "#F8EF99", "#FFFCEE"],
      ["#3498DB", "#2ECC71", "#F1C40F", "#E74C3C", "#9B59B6"],
      ["#8E44AD", "#1ABC9C", "#D35400", "#2C3E50", "#27AE60"],
      ["#E67E22", "#16A085", "#2980B9", "#F39C12", "#34495E"],
    ],
  },
  {
    id: "ribbon3",
    viewBox: "0 0 400 200",
    selectedpalate: 0,
    data: [
      {
        fill: "#6269AB",
        id: "ribbon3-1",
        d: `M64.7,54.9l7,11.2c-4.2-0.3-8.4-0.3-12.4,0c-1.1,0.1-2.3,0.2-3.4,0.3h0c-1.1,0.1-2.3,0.2-3.4,0.4
             c-1,0.1-2,0.3-2.9,0.4c-13.9,2.2-24,6.6-24,6.6s4.2-17.3,10.3-25.6L0,33.5c0,0,13.5-4.5,34.6-7.7c1.1-0.2,2.2-0.3,3.3-0.5
             c1.1-0.2,2.3-0.3,3.5-0.5c1-0.1,2.1-0.3,3.2-0.4c27.6-3.2,64.8-3.4,101.8,9C86.7,38.2,70.1,49.4,66,53.4c-0.1,0.1-0.2,0.1-0.2,0.2
             C65,54.4,64.8,54.8,64.7,54.9C64.7,54.9,64.7,54.9,64.7,54.9L64.7,54.9z`,
      },
      {
        fill: "#6269AB",
        id: "ribbon3-2",
        d: `M366.7,152.6c6.6,9,7.5,24.7,7.5,24.7c-6.5-2.6-13.1-4.5-19.6-5.8c-1-0.2-1.9-0.4-2.9-0.5
             c-1.1-0.2-2.2-0.4-3.3-0.5c-1.1-0.2-2.3-0.3-3.4-0.5c-32.7-4-60.3,5.2-60.3,5.2s0-0.2,0.1-0.5c0-0.2,0.1-0.4,0.2-0.6
             c0.2-0.5,0.4-1,0.7-1.7c0.1-0.2,0.2-0.5,0.3-0.7c0.1-0.2,0.2-0.5,0.4-0.7v0c0.1-0.2,0.2-0.4,0.3-0.6v0c0.1-0.2,0.2-0.4,0.4-0.7v0
             c0.2-0.3,0.4-0.6,0.6-0.9c0.1-0.2,0.3-0.5,0.5-0.7c0.5-0.7,1.1-1.5,1.7-2.2v0c0.2-0.2,0.4-0.5,0.7-0.7v0c0.2-0.2,0.5-0.5,0.7-0.7
             c0.1-0.1,0.2-0.2,0.2-0.2c0.1-0.1,0.2-0.2,0.2-0.2c0.1-0.1,0.2-0.2,0.2-0.2c0.1-0.1,0.2-0.2,0.3-0.2c0,0,0,0,0,0
             c0.2-0.2,0.4-0.3,0.5-0.5c0.4-0.3,0.7-0.6,1.1-1c0.2-0.2,0.4-0.3,0.6-0.5c0.2-0.2,0.4-0.3,0.6-0.5c0.2-0.1,0.4-0.3,0.7-0.4
             c0.9-0.6,1.9-1.2,2.9-1.7c0.5-0.3,1.1-0.5,1.6-0.8c0.3-0.1,0.6-0.2,0.8-0.4c0.9-0.3,1.8-0.7,2.7-0.9c0,0,0,0,0,0
             c0.2-0.1,0.4-0.1,0.7-0.2c0.2-0.1,0.5-0.1,0.7-0.2c0,0,0,0,0,0c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.3-0.1,0.4-0.1c0.1,0,0.2-0.1,0.4-0.1
             c0.1,0,0.2,0,0.4-0.1c2.7-0.6,5.7-0.9,9.1-0.9h0v0l18.4-26.3l0,0c7.2-0.5,14.8-0.1,22,0.8c1.1,0.1,2.1,0.3,3.2,0.4
             c1.1,0.2,2.3,0.3,3.4,0.5c1.1,0.2,2.1,0.4,3.2,0.6c18.9,3.5,34,9.3,34,9.3C373.8,146.6,366.7,152.6,366.7,152.6z`,
      },
      {
        fill: "#A8AFD7",
        id: "ribbon3-3",
        d: `M13,38.9c10.9-2.8,22-4.6,33.2-6c11.2-1.3,22.4-2,33.7-1.9c5.6,0.1,11.3,0.3,16.9,0.8
             c5.6,0.5,11.2,1.2,16.7,2.2c5.5,1.1,11,2.3,16.4,4c5.4,1.7,10.6,3.8,15.7,6.2c-5.1-2.3-10.4-4.3-15.8-5.9
             c-5.4-1.6-10.9-2.8-16.4-3.8c-5.5-0.9-11.1-1.6-16.7-2.1c-5.6-0.4-11.2-0.7-16.8-0.7c-11.2,0-22.5,0.6-33.6,1.8
             c-5.6,0.6-11.2,1.3-16.7,2.2C24.1,36.7,18.5,37.6,13,38.9z M313.8,137.8c8.1-0.8,16.3-1.3,24.5-1.3c8.2,0,16.4,0.5,24.5,1.7
             c8.1,1.2,16.1,3,23.8,5.8c-7.6-3-15.6-5.1-23.7-6.4c-8.1-1.3-16.3-1.8-24.5-1.9c-8.2-0.1-16.4,0.5-24.6,1.4
             c-8.2,0.9-16.3,2.3-24.3,4C297.5,139.7,305.6,138.6,313.8,137.8z M35.3,63.9c1.2-0.4,2.5-0.6,3.8-1l3.8-0.8
             c5.1-1.1,10.2-1.8,15.3-2.3c1.3-0.1,2.6-0.3,3.9-0.3l3.9-0.1c1.3,0,2.6,0,3.9,0l1.9,0c0.6,0,1.3,0.1,1.9,0.1l3.9,0.3l3.9,0.5
             l1.9,0.2l1.9,0.4l3.8,0.8l-3.8-1l-1.9-0.5l-1.9-0.3l-3.9-0.6l-3.9-0.4c-5.2-0.5-10.4-0.4-15.6,0c-5.2,0.4-10.4,1.3-15.4,2.4
             c-5.1,1.2-10.1,2.7-14.8,4.8C30.3,65.3,32.8,64.5,35.3,63.9z M293.4,165.3c3.8-0.8,7.5-1.6,11.4-2.1c7.6-1.2,15.3-1.8,23-1.9
             c7.7-0.1,15.4,0.4,23,1.7c1.9,0.3,3.8,0.7,5.7,1c1.9,0.4,3.8,0.8,5.6,1.4c3.7,0.9,7.4,2.2,11,3.5c-7.1-3-14.6-5.2-22.2-6.5
             c-7.6-1.4-15.4-1.9-23.1-1.9c-3.9,0-7.7,0.2-11.6,0.6c-3.9,0.4-7.7,0.8-11.5,1.5c-7.6,1.3-15.2,3.1-22.4,5.7
             C285.9,167,289.7,166.1,293.4,165.3z`,
      },
      {
        fill: "#6269AB",
        id: "ribbon3-4",
        d: `M302.4,54.9l-25.6,39.7C239,82,202.8,79.1,172.4,80.2c-0.1,0-0.1,0-0.2,0h0c-2.9,0.1-5.7,0.2-8.4,0.4
             c-44.6,2.8-74.4,14-74.4,14L71.7,66.1v0h0l-7-11.2h0c23-6.7,49.7-13.8,81.6-16.9C188.2,33.8,239.1,36.3,302.4,54.9z M223.4,97.4
             c-61.3,0-105.2,15.1-105.2,15.1l21.8,38.1c0,0,55.6-19,125.4-8.4c16.2,2.5,33.2,6.5,50.4,12.8c0,0,0,0,0,0v0l18.4-26.3l0,0l7.4-10.6
             C299.8,102.4,258.7,97.4,223.4,97.4z`,
      },
      {
        fill: "#3A4277",
        id: "ribbon3-5",
        d: `M276.8,94.6c-20-2.2-37.8-0.7-53.4,2.8c-61.3,0-105.2,15.1-105.2,15.1s13.1-16.6,45.5-31.9
             c2.8-0.2,5.6-0.3,8.4-0.4h0c0.1,0,0.1,0,0.2,0C202.8,79.1,239,82,276.8,94.6z M66,53.4c-0.1,0.1-0.1,0.2-0.2,0.2
             c-0.7,0.7-1,1.2-1,1.2v0c23-6.7,49.7-13.8,81.6-16.9v-4.4C86.7,38.2,70.1,49.4,66,53.4z M315.8,155c-17.2-6.3-34.2-10.3-50.4-12.8
             l19.2,32.9c0,0,0-0.2,0.1-0.5c0-0.2,0.1-0.4,0.2-0.6c0.2-0.5,0.4-1,0.7-1.7c0.1-0.2,0.2-0.5,0.3-0.7c0.1-0.2,0.2-0.5,0.4-0.7v0
             c0.1-0.2,0.2-0.4,0.3-0.6c0,0,0,0,0,0v0c0.1-0.2,0.2-0.4,0.4-0.7v0c0.2-0.3,0.4-0.6,0.6-0.9c0.1-0.2,0.3-0.5,0.5-0.7
             c0.5-0.7,1.1-1.5,1.7-2.2v0c0.2-0.2,0.4-0.5,0.7-0.7h0v0c0.2-0.2,0.5-0.5,0.7-0.7c0.1-0.1,0.2-0.2,0.2-0.2c0.1-0.1,0.2-0.2,0.2-0.2
             c0.1-0.1,0.2-0.2,0.2-0.2c0.1-0.1,0.2-0.2,0.3-0.2c0,0,0,0,0,0c0.2-0.2,0.4-0.3,0.5-0.5c0.4-0.3,0.7-0.6,1.1-1
             c0.2-0.2,0.4-0.3,0.6-0.5c0.2-0.2,0.4-0.3,0.6-0.5c0.2-0.1,0.4-0.3,0.7-0.4c0.9-0.6,1.9-1.2,2.9-1.7c0.5-0.3,1.1-0.5,1.6-0.8
             c0.3-0.1,0.6-0.2,0.8-0.4c0.2-0.1,0.4-0.2,0.6-0.3c0.4-0.2,0.9-0.3,1.4-0.5c0.2-0.1,0.5-0.1,0.7-0.2c0,0,0,0,0,0
             c0.2-0.1,0.4-0.1,0.7-0.2c0.2-0.1,0.5-0.1,0.7-0.2c0,0,0,0,0,0c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.3-0.1,0.4-0.1c0.1,0,0.2-0.1,0.4-0.1
             c0.1,0,0.2,0,0.4-0.1C309.4,155.3,312.5,155,315.8,155L315.8,155C315.9,155,315.8,155,315.8,155z`,
      },
      {
        fill: "#A8AFD7",
        id: "ribbon3-6",
        d: `M70.2,63.7l6.9-2.1l3.4-1l3.5-1l6.9-1.9l7-1.8l3.5-0.9c1.2-0.3,2.3-0.5,3.5-0.8l7-1.5c2.3-0.5,4.7-0.9,7.1-1.3
             l7.1-1.3c19-3.1,38.2-4.5,57.4-4.5l7.2,0.1c2.4,0,4.8,0,7.2,0.2c4.8,0.3,9.6,0.5,14.4,0.9l14.3,1.5c4.8,0.7,9.5,1.4,14.2,2.1
             c2.4,0.3,4.7,0.8,7.1,1.3l7.1,1.4c2.4,0.5,4.7,0.9,7.1,1.4l7,1.7c9.4,2.1,18.5,5,27.7,7.6c-9.3-2.4-18.5-5.1-27.9-7l-7-1.6
             c-2.3-0.5-4.7-0.9-7.1-1.3l-7.1-1.3c-2.4-0.4-4.7-0.9-7.1-1.2c-18.9-3-38.1-4.5-57.2-4.5c-19.1-0.1-38.3,1.4-57.2,4.2l-7.1,1.2
             c-2.4,0.4-4.7,0.8-7.1,1.3l-7,1.4c-1.2,0.2-2.3,0.5-3.5,0.7L98,56.4l-7,1.6l-7,1.8l-3.5,0.9l-3.5,1L70.2,63.7z M96.4,83.1l6.1-1.6
             l6.1-1.4c4.1-1,8.2-1.7,12.3-2.6c4.1-0.8,8.2-1.4,12.4-2.1c16.5-2.5,33.3-3.8,50-3.7c16.7,0,33.4,1.3,50,3.9c2.1,0.2,4.1,0.6,6.2,1
             l6.2,1.1c2.1,0.4,4.1,0.7,6.2,1.2l6.1,1.4c8.2,1.6,16.3,4,24.4,6.1c-8-2.3-16-4.8-24.2-6.7l-6.1-1.5c-2-0.5-4.1-0.8-6.2-1.2
             l-6.2-1.2c-2.1-0.4-4.1-0.8-6.2-1.1c-4.1-0.6-8.3-1.3-12.4-1.8l-12.5-1.3c-4.2-0.3-8.4-0.5-12.6-0.8c-2.1-0.2-4.2-0.2-6.3-0.2
             l-6.3-0.1c-16.8,0-33.6,1.3-50.1,4c-4.1,0.8-8.3,1.5-12.4,2.3l-6.1,1.3c-2.1,0.4-4.1,0.9-6.1,1.4l-6.1,1.6l-6,1.7
             c-4,1.1-8,2.4-12,3.6C88.3,85.4,92.3,84.1,96.4,83.1z M129.7,119.4c1.1-0.3,2.2-0.6,3.3-0.9l3.3-0.8l6.6-1.6l6.6-1.4l3.3-0.7
             l3.3-0.6l6.7-1.2c2.2-0.4,4.5-0.6,6.7-1c2.2-0.3,4.5-0.6,6.7-0.9c17.9-2.1,35.9-2.9,53.9-2.3c18,0.5,36,2.3,53.7,5.3
             c1.1,0.2,2.2,0.3,3.3,0.5l3.3,0.6l6.6,1.3c2.2,0.4,4.4,0.8,6.6,1.3l6.6,1.5c8.8,1.9,17.5,4.4,26.2,6.7c-8.7-2.5-17.3-5.2-26.1-7.3
             l-6.6-1.6c-2.2-0.5-4.4-0.9-6.6-1.4l-6.6-1.4l-3.3-0.7c-1.1-0.2-2.2-0.4-3.3-0.6c-17.8-3.2-35.8-5-53.8-5.6
             c-18.1-0.5-36.2,0.3-54.1,2.6c-2.2,0.3-4.5,0.7-6.7,1c-2.2,0.4-4.5,0.6-6.7,1.1l-6.7,1.3l-3.3,0.6l-3.3,0.7l-6.6,1.5l-6.5,1.7
             l-3.3,0.9c-1.1,0.3-2.2,0.6-3.2,1l-6.5,2L129.7,119.4z M147.9,141.4l5.7-1.5l5.7-1.4l2.8-0.7l2.9-0.6l5.7-1.2c1.9-0.4,3.8-0.7,5.8-1
             c1.9-0.3,3.8-0.7,5.8-1c15.4-2.3,31-3.3,46.6-2.8c15.6,0.4,31.1,2.3,46.4,5.2l11.4,2.5l2.9,0.6l2.8,0.7l5.7,1.5l5.7,1.5
             c1.9,0.5,3.7,1.1,5.6,1.7l11.2,3.4l-11.1-3.7c-1.9-0.6-3.7-1.3-5.6-1.8l-5.6-1.6l-5.6-1.6l-2.8-0.8l-2.9-0.7l-11.4-2.6
             c-15.3-3.1-30.9-5-46.5-5.5c-15.6-0.4-31.3,0.5-46.8,3c-1.9,0.3-3.8,0.7-5.8,1c-1.9,0.4-3.8,0.7-5.8,1.1l-5.7,1.3l-2.9,0.6l-2.8,0.7
             l-5.7,1.5l-5.6,1.6c-3.8,1.1-7.5,2.3-11.2,3.4C140.3,143.6,144.1,142.4,147.9,141.4z`,
      },
    ],
    palette: [
      ["#6269AB", "#6269AB", "#A8AFD7", "#6269AB", "#3A4277", "#A8AFD7"],
      ["#3498DB", "#2ECC71", "#F1C40F", "#E74C3C", "#9B59B6", "#1ABC9C"],
      ["#8E44AD", "#1ABC9C", "#D35400", "#2C3E50", "#27AE60", "#F39C12"],
      ["#E67E22", "#16A085", "#2980B9", "#F39C12", "#34495E", "#D35400"],
    ],
  },
  {
    id: "ribbon4",
    viewBox: "0 0 400 85.823",
    selectedpalate: 0,
    data: [
      {
        fill: "#1A6284",
        id: "ribbon4-1",
        d: `M84.87,85.822 L0,85.822 L27.564,53.201 L0,20.578 L84.87,20.578 Z`,
      },
      {
        fill: "#1A6284",
        id: "ribbon4-2",
        d: `M315.158,85.822 L400.026,85.822 L372.463,53.201 L400.026,20.578 L315.158,20.578 Z`,
      },
      {
        fill: "#1E7297",
        id: "ribbon4-3",
        d: `M44.35,0 L355.678,0 L355.678,65.242 L44.35,65.242 Z`,
      },
      {
        fill: "#125473",
        id: "ribbon4-4",
        d: `M44.35,65.242 L84.87,65.242 L84.87,85.822 Z`,
      },
      {
        fill: "#125473",
        id: "ribbon4-5",
        d: `M355.678,65.242 L315.158,65.242 L315.158,85.822 Z`,
      },
    ],
    palette: [
      ["#1A6284", "#1A6284", "#1E7297", "#125473", "#125473"],
      ["#8E44AD", "#1ABC9C", "#D35400", "#2C3E50", "#27AE60"],
      ["#E67E22", "#16A085", "#2980B9", "#F39C12", "#34495E"],
      ["#D35400", "#8E44AD", "#C0392B", "#1ABC9C", "#2E86C1"],
    ],
  },
  {
    id: "ribbon5",
    viewBox: "0 0 400 200",

    selectedpalate: 0,
    data: [
      {
        fill: "#CE483C",
        id: "ribbon5-1",
        d: `M80.8,57.1L62.5,87.5l-4.3,7.1C20.7,69.5,0,43.3,0,43.3l29.8,1.5l-1.4-34.2c0,0,8.4,11.3,25,25.8
             C60.8,42.9,70,50.1,80.8,57.1z M324,105.6c-32.4,18.5-74.4,33.8-124,33.8S108.4,124,76,105.6l3.2-7.5l14.1-33.3l0,0c0,0,0,0,0.1,0
             c8.3,4.8,17.4,9.3,27.3,13.4c22.5,9.3,49,16.3,79.3,18c30.4-1.7,56.9-8.7,79.4-18c9.9-4.1,19-8.7,27.4-13.4l14,33.2L324,105.6z
              M400,43.3c0,0-20.8,26.3-58.3,51.4l-4.3-7.1l-18.3-30.4c10.8-7.1,20-14.2,27.5-20.7c16.5-14.4,25-25.8,25-25.8l-1.4,34.2L400,43.3z`,
      },
      {
        fill: "#BF423B",
        id: "ribbon5-2",
        d: `M124.6,65.2c-19.7,3.7-30.3-0.1-31.3-0.4c0,0,0,0-0.1,0l0,0L79.2,98c-6.2-3.4-11.8-7-16.6-10.5l18.3-30.4
             C62.4,41.9,60,25.8,60,25.8S85.6,53.7,124.6,65.2z M319.2,57.1l18.3,30.4c-4.8,3.5-10.4,7.1-16.6,10.5l-14.1-33.3
             c-19.7,5.3-31.3,0.5-31.3,0.5c39-11.5,64.6-39.4,64.6-39.4S336.8,44.3,319.2,57.1z`,
      },
      {
        fill: "#AA3835",
        id: "ribbon5-3",
        d: `M124.6,65.2l-3.9,13c-9.9-4.1-19-8.7-27.3-13.4C94.3,65.1,104.9,68.9,124.6,65.2z M80.8,57.1
             C70,50,60.8,42.9,53.3,36.4L60,25.8C60,25.8,62.4,41.9,80.8,57.1z M346.6,36.4c-7.5,6.5-16.6,13.7-27.5,20.7
             C336.8,44.3,340,25.8,340,25.8L346.6,36.4z M306.8,64.7c-8.3,4.8-17.5,9.3-27.4,13.4l-3.9-13C275.4,65.2,287,70,306.8,64.7z`,
      },
    ],
    palette: [
      ["#CE483C", "#BF423B", "#AA3835"],
      ["#3498DB", "#2ECC71", "#F1C40F"],
      ["#8E44AD", "#1ABC9C", "#D35400"],
      ["#E67E22", "#16A085", "#2980B9"],
    ],
  },
  {
    id: "ribbon6",
    viewBox: "0 0 400 100",
    selectedpalate: 0,
    data: [
      {
        fill: "#E1DD6D",
        id: "ribbon6-1",
        d: `M399.5,84.2l-26.3-22.8l8.4-22.8h-35.9l-9-22.8c-136.7,24.1-273.4,0-273.4,0l-9,22.8H18.4l8.4,22.8L0.5,84.2
      h71.8L45.4,61.4c0.4,0.2,12.8,2.6,33.8,5.3C127.8,73,222.4,81.1,321,67.1c11.2-1.6,22.4-3.5,33.7-5.7l-26.9,22.8H399.5z`,
      },
      {
        fill: "#F5F09B",
        id: "ribbon6-2",
        d: `M34.1,76.8h-9.6c-0.3,0-0.5,0.2-0.5,0.4s0.2,0.5,0.5,0.5h9.6c0.3,0,0.4-0.2,0.4-0.5S34.3,76.8,34.1,76.8z
       M43.2,77.2c0,0.3,0.2,0.5,0.5,0.5h9.6c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.4-0.5-0.4h-9.6C43.4,76.8,43.2,77,43.2,77.2z M362.3,77.2
      c0,0.3,0.2,0.5,0.5,0.5h9.6c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.4-0.5-0.4h-9.6C362.5,76.8,362.3,77,362.3,77.2z M353.2,76.8h-9.6
      c-0.3,0-0.5,0.2-0.5,0.4s0.2,0.5,0.5,0.5h9.6c0.3,0,0.5-0.2,0.5-0.5S353.4,76.8,353.2,76.8z M65.7,56.5c-3.3-0.5-6.5-1-9.5-1.5
      c-0.3,0-0.5,0.1-0.5,0.4c0,0.3,0.1,0.5,0.4,0.5c3,0.5,6.2,1,9.5,1.5h0.1c0.2,0,0.4-0.2,0.5-0.4C66.1,56.7,65.9,56.5,65.7,56.5z
       M199.2,66.5c-3.2,0-6.4-0.1-9.6-0.1l0,0c-0.2,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5c3.2,0,6.4,0.1,9.6,0.1c0.3,0,0.5-0.2,0.4-0.5
      C199.7,66.7,199.5,66.5,199.2,66.5z M141.8,64.4c-3.2-0.2-6.4-0.4-9.5-0.7c-0.3,0-0.5,0.2-0.5,0.4s0.2,0.5,0.4,0.5
      c3.1,0.2,6.3,0.5,9.6,0.7l0,0c0.2,0,0.4-0.2,0.4-0.4C142.3,64.6,142.1,64.4,141.8,64.4z M122.7,63c-3.3-0.3-6.4-0.5-9.5-0.8
      c-0.3,0-0.5,0.2-0.5,0.4c0,0.3,0.2,0.5,0.4,0.5c3.1,0.3,6.3,0.6,9.5,0.9l0,0c0.2,0,0.4-0.2,0.4-0.4C123.2,63.2,123,63,122.7,63z
       M84.7,59c-1.9-0.2-3.7-0.5-5.4-0.7c-1.4-0.2-2.8-0.4-4.1-0.5c-0.3,0-0.5,0.1-0.5,0.4c0,0.3,0.1,0.5,0.4,0.5
      c1.3,0.2,2.7,0.4,4.1,0.5c1.8,0.2,3.6,0.5,5.4,0.7c0,0,0,0,0.1,0c0.2,0,0.4-0.2,0.4-0.4S84.9,59.1,84.7,59z M180.1,66.1
      c-3.2-0.1-6.4-0.2-9.6-0.3c-0.3,0-0.5,0.2-0.5,0.4c0,0.3,0.2,0.5,0.4,0.5c3.2,0.1,6.4,0.2,9.6,0.3l0,0c0.3,0,0.5-0.2,0.5-0.5
      C180.5,66.3,180.3,66.1,180.1,66.1z M161,65.5c-3.2-0.2-6.4-0.3-9.6-0.5c-0.3,0-0.5,0.2-0.5,0.4c0,0.3,0.2,0.5,0.4,0.5
      c3.1,0.2,6.3,0.3,9.6,0.5l0,0c0.2,0,0.4-0.2,0.5-0.4C161.4,65.7,161.2,65.5,161,65.5z M218.4,66.4L218.4,66.4
      c-3.2,0-6.4,0.1-9.6,0.1c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5c3.2,0,6.4,0,9.6-0.1c0.3,0,0.5-0.2,0.5-0.5S218.7,66.4,218.4,66.4z
       M103.7,61.2c-3.3-0.3-6.5-0.7-9.5-1c-0.3,0-0.5,0.2-0.5,0.4c0,0.3,0.1,0.5,0.4,0.5c3.1,0.3,6.2,0.7,9.5,1l0,0
      c0.2,0,0.4-0.2,0.4-0.4C104.1,61.5,103.9,61.2,103.7,61.2z M294.9,61.9c-3.2,0.3-6.4,0.7-9.5,0.9c-0.3,0-0.4,0.2-0.4,0.5
      c0,0.2,0.2,0.4,0.5,0.4l0,0c3.2-0.3,6.4-0.6,9.5-1c0.3,0,0.4-0.3,0.4-0.5C295.3,62.1,295.1,61.9,294.9,61.9z M313.9,59.7
      c-3.1,0.4-6.3,0.8-9.5,1.2c-0.3,0-0.4,0.3-0.4,0.5s0.2,0.4,0.5,0.4c0,0,0,0,0.1,0c3.2-0.4,6.4-0.8,9.5-1.2c0.3,0,0.4-0.3,0.4-0.5
      C314.4,59.8,314.1,59.6,313.9,59.7z M275.8,63.7c-3.1,0.3-6.3,0.5-9.5,0.7c-0.3,0-0.4,0.2-0.4,0.5c0,0.2,0.2,0.4,0.5,0.4l0,0
      c3.2-0.2,6.4-0.5,9.6-0.7c0.2,0,0.4-0.2,0.4-0.5C276.3,63.9,276,63.7,275.8,63.7z M256.7,65c-3.2,0.2-6.4,0.4-9.6,0.5
      c-0.3,0-0.4,0.2-0.4,0.5c0,0.2,0.2,0.4,0.5,0.4l0,0c3.2-0.2,6.4-0.3,9.6-0.5c0.3,0,0.4-0.2,0.4-0.5C257.1,65.2,256.9,65,256.7,65z
       M332.8,56.9c-3.1,0.5-6.3,1-9.5,1.4c-0.3,0-0.4,0.3-0.4,0.5s0.2,0.4,0.5,0.4c0,0,0,0,0.1,0c3.2-0.5,6.4-1,9.5-1.5
      c0.2,0,0.4-0.3,0.4-0.5C333.3,57,333,56.9,332.8,56.9z M237.5,65.9c-3.2,0.1-6.4,0.2-9.6,0.3c-0.3,0-0.5,0.2-0.4,0.5
      c0,0.2,0.2,0.4,0.5,0.4l0,0c3.2-0.1,6.4-0.2,9.6-0.3c0.3,0,0.5-0.2,0.4-0.5S237.8,65.9,237.5,65.9z M360.1,45.4h7.2
      c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5h-7.2c-0.3,0-0.5,0.2-0.5,0.5S359.9,45.4,360.1,45.4z M399.9,84.5l0.1-0.1l0,0v-0.1l0,0
      v-0.1v-0.1c0,0,0-0.1-0.1-0.1l0,0l0,0l-26.1-22.6l5.9-16.1c0,0,0,0,0-0.1l2.3-6.3c0-0.1,0.1-0.1,0.1-0.2l0,0l0,0v-0.1
      c0,0,0-0.1-0.1-0.1l0,0c0-0.1-0.1-0.1-0.2-0.1s-0.2,0-0.2,0H346l-8.9-22.5c-0.1-0.2-0.4-0.3-0.6-0.3l0,0
      c-135,23.8-271.7,0.2-273.1,0c-0.1,0-0.1,0-0.2,0l0,0c0,0-0.1,0-0.1,0.1l0,0c0,0-0.1,0-0.1,0.1c0,0,0,0,0,0.1l0,0l-2.5,6.4v0.1
      l-6.3,16H18.5c-0.1,0-0.2,0-0.3,0c-0.2,0.1-0.3,0.2-0.3,0.4l0,0c0,0.1,0,0.1,0.1,0.2l2.5,6.7l0,0l5.8,15.7L0.2,83.8l0,0
      c0,0,0,0,0,0.1c0,0,0,0,0,0.1v0.1c0,0,0,0,0,0.1l0,0v0.1l0,0c0,0,0,0.1,0.1,0.1l0,0l0,0l0.1,0.1l0,0c0.1,0,0.1,0,0.2,0h71.8
      c0.1,0,0.1,0,0.2,0l0,0l0,0c0,0,0,0,0.1,0l0,0c0,0,0-0.1,0.1-0.1l0,0l0,0l0,0l0,0l6.7-17.1c16.5,2.2,38.1,4.5,63.2,6.1
      c18,1.2,39.1,2,62.3,2c35.1,0,74.9-2,115.7-7.7l6.6,16.7c0,0,0,0,0,0.1l0,0c0,0,0,0.1,0.1,0.1l0,0c0,0,0,0,0.1,0l0,0c0,0,0,0,0.1,0
      s0.1,0,0.2,0h71.8C399.7,84.6,399.7,84.6,399.9,84.5L399.9,84.5C399.8,84.6,399.8,84.5,399.9,84.5L399.9,84.5L399.9,84.5z
       M380.9,39.1l-2,5.4h-4.5c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h4.1l-5.8,15.8l0,0c-0.1,0.2,0,0.4,0.1,0.5l17.4,15h-8.4
      c-0.3,0-0.5,0.2-0.5,0.4s0.2,0.5,0.5,0.5h9.4l7,6.1h-69.4l25.9-21.9c0.1-0.1,0.2-0.2,0.2-0.4l0,0v-0.1l0,0l0,0v-0.1l-6.2-15.8h4.1
      c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.5-0.5-0.5h-4.5l-2.1-5.4C346.2,39.1,380.9,39.1,380.9,39.1z M51.4,44.9h-4.5c-0.3,0-0.5,0.2-0.5,0.4
      s0.2,0.5,0.5,0.5H51l-6.1,15.4l0,0l0,0c-0.1,0.2,0,0.4,0.1,0.5l0,0l0,0l17.7,15l0,0c-0.3,0-0.5,0.2-0.5,0.4s0.2,0.5,0.5,0.5h1.1
      l7.2,6.1H1.7l7-6.1H15c0.3,0,0.4-0.2,0.4-0.5s-0.2-0.4-0.5-0.4H9.7l17.4-15l0,0l0.1-0.1l0,0c0-0.1,0-0.2,0-0.3v-0.1l0,0l-5.7-15.4
      h4.1c0.3,0,0.5-0.2,0.5-0.5s-0.2-0.4-0.5-0.4h-4.5L19,39.1h34.6L51.4,44.9z M143.8,72.5c-25.7-1.6-47.7-4-64.4-6.1l0,0
      c-0.1,0-0.2,0-0.2,0c-18.8-2.5-30.7-4.6-33.1-5.2l6.1-15.6l0,0l8.9-22.7c0.6,0.1,2.1,0.3,4.4,0.7c0,0,0,0,0.1,0
      c0.2,0,0.4-0.2,0.4-0.4c0-0.3-0.1-0.5-0.4-0.5c-2-0.3-3.4-0.5-4.2-0.6l2.2-5.6c5.2,0.9,64.4,10.6,141.9,10.6
      c40.4,0,85.8-2.6,131-10.6l2.2,5.7c-1.4,0.2-2.8,0.5-4.2,0.7c-0.3,0-0.4,0.3-0.4,0.5s0.2,0.4,0.5,0.4c0,0,0,0,0.1,0
      c1.5-0.2,2.9-0.5,4.4-0.7l6.3,15.9l0,0l2.5,6.3c0,0,0,0,0,0.1l3.4,8.5c-2.9,0.6-5.9,1.1-8.9,1.6c-0.3,0-0.4,0.3-0.4,0.5
      s0.2,0.4,0.5,0.4c0,0,0,0,0.1,0c3-0.5,6.1-1.1,9.1-1.7l2.6,6.5C275.3,76.4,196.3,75.8,143.8,72.5z M102.4,28.1
      c0.2,0,0.4-0.2,0.4-0.4c0-0.3-0.2-0.5-0.4-0.5c-3.3-0.3-6.3-0.7-9.3-1c-0.3,0-0.5,0.2-0.5,0.4c0,0.3,0.2,0.5,0.4,0.5
      C96,27.5,99.1,27.8,102.4,28.1L102.4,28.1z M83.9,26c0.2,0,0.4-0.2,0.4-0.4s-0.1-0.5-0.4-0.5c-3.1-0.4-6.2-0.8-9.2-1.2
      c-0.3,0-0.5,0.1-0.5,0.4s0.1,0.5,0.4,0.5C77.6,25.3,80.7,25.6,83.9,26L83.9,26z M158.2,32.3c0.2,0,0.4-0.2,0.4-0.4
      c0-0.3-0.2-0.5-0.4-0.5c-3.2-0.2-6.3-0.3-9.3-0.5c-0.3,0-0.5,0.2-0.5,0.4s0.2,0.5,0.4,0.5C151.9,32,155,32.2,158.2,32.3L158.2,32.3z
       M251.7,31.9c0-0.3-0.2-0.4-0.5-0.4c-3.1,0.2-6.2,0.3-9.3,0.4c-0.3,0-0.4,0.2-0.4,0.5c0,0.2,0.2,0.4,0.5,0.4l0,0
      c3.1-0.1,6.2-0.3,9.3-0.4C251.5,32.4,251.7,32.2,251.7,31.9z M270.3,30.8c0-0.3-0.2-0.4-0.5-0.4c-3,0.2-6.2,0.4-9.3,0.6
      c-0.3,0-0.4,0.2-0.4,0.5c0,0.2,0.2,0.4,0.5,0.4l0,0c3.1-0.2,6.2-0.4,9.3-0.6C270.1,31.2,270.3,31,270.3,30.8z M288.8,29.2
      c0-0.3-0.2-0.4-0.5-0.4c-3,0.3-6.2,0.6-9.3,0.9c-0.3,0-0.4,0.2-0.4,0.5c0,0.2,0.2,0.4,0.5,0.4l0,0c3.1-0.3,6.2-0.6,9.3-0.9
      C288.7,29.6,288.8,29.4,288.8,29.2z M325.8,24.6c0-0.3-0.3-0.4-0.5-0.4c-3,0.5-6.1,0.9-9.2,1.3c-0.3,0-0.4,0.3-0.4,0.5
      s0.2,0.4,0.5,0.4c0,0,0,0,0.1,0c3.1-0.4,6.2-0.9,9.2-1.3C325.7,25,325.8,24.8,325.8,24.6z M307.3,27.1c0-0.2-0.3-0.4-0.5-0.4
      c-3,0.4-6.2,0.7-9.2,1.1c-0.3,0-0.4,0.3-0.4,0.5s0.2,0.4,0.5,0.4l0,0c3.1-0.3,6.2-0.7,9.3-1.1C307.2,27.6,307.4,27.4,307.3,27.1z
       M139.6,31.3c0.2,0,0.4-0.2,0.5-0.4c0-0.3-0.2-0.5-0.4-0.5c-3.2-0.2-6.3-0.4-9.3-0.7c-0.3,0-0.5,0.2-0.5,0.4s0.2,0.5,0.4,0.5
      C133.3,30.8,136.4,31,139.6,31.3C139.5,31.3,139.5,31.3,139.6,31.3z M176.8,33c0.3,0,0.5-0.2,0.5-0.4c0-0.3-0.2-0.5-0.4-0.5
      c-3.1-0.1-6.2-0.2-9.3-0.3c-0.3,0-0.5,0.2-0.5,0.4s0.2,0.5,0.4,0.5C170.5,32.8,173.6,33,176.8,33L176.8,33z M195.9,33
      c0-0.3-0.2-0.5-0.5-0.5c-3.1,0-6.2-0.1-9.3-0.1l0,0c-0.2,0-0.4,0.2-0.4,0.4c0,0.3,0.2,0.5,0.4,0.5c3.1,0.1,6.2,0.1,9.3,0.2
      C195.7,33.4,195.9,33.2,195.9,33z M121,29.9c0.2,0,0.4-0.2,0.4-0.4c0-0.3-0.2-0.5-0.4-0.5c-3.2-0.3-6.3-0.5-9.3-0.8
      c-0.3,0-0.5,0.2-0.5,0.4c0,0.3,0.2,0.5,0.4,0.5C114.7,29.3,117.8,29.6,121,29.9L121,29.9z M233.1,32.7c0-0.3-0.2-0.4-0.5-0.4
      c-3.1,0.1-6.2,0.2-9.3,0.2c-0.3,0-0.4,0.2-0.4,0.5c0,0.2,0.2,0.4,0.5,0.4c3.1-0.1,6.2-0.1,9.3-0.2C232.9,33.1,233.1,32.9,233.1,32.7
      z M214.5,33c0-0.3-0.2-0.5-0.5-0.5c-2.6,0-5.2,0-7.7,0h-1.6c-0.3,0-0.5,0.2-0.5,0.4s0.2,0.5,0.5,0.5h1.6c2.6,0,5.1,0,7.7,0
      C214.3,33.5,214.5,33.3,214.5,33z M39.8,44.9h-7.1c-0.3,0-0.5,0.2-0.5,0.4s0.2,0.5,0.5,0.5h7.1c0.3,0,0.5-0.2,0.5-0.5
      S40.1,44.9,39.8,44.9z`,
      },
    ],
    palette: [
      ["#E1DD6D", "#F5F09B"],
      ["#3498DB", "#2ECC71"],
      ["#8E44AD", "#1ABC9C"],
      ["#D35400", "#2C3E50"],
    ],
  },
  {
    id: "ribbon7",
    viewBox: "0 0 101.575 201.97",
    selectedpalate: 0,
    data: [
      {
        fill: "#63C08C",
        id: "ribbon7-1",
        d: `M101.493,201.97 L50.705,175.921 -0.082,201.97 V0 H101.493 Z`,
      },
      {
        fill: "#A2D397",
        id: "ribbon7-2",
        d: `M25.301,188.95 L9.985,196.806 V0 H25.301 Z`,
      },
      {
        fill: "#A2D397",
        id: "ribbon7-3",
        d: `M76.117,188.95 L91.433,196.806 V0 H76.117 Z`,
      },
    ],
    palette: [
      ["#63C08C", "#A2D397", "#A2D397"],
      ["#3498DB", "#2ECC71", "#F1C40F"],
      ["#8E44AD", "#1ABC9C", "#D35400"],
      ["#E67E22", "#16A085", "#2980B9"],
    ],
  },
  {
    id: "ribbon8",
    viewBox: "0 0 101.575 201.971",
    selectedpalate: 0,
    data: [
      {
        fill: "#A1D296",
        id: "ribbon8-1",
        d: `M101.575,201.969 L88.704,188.946 76.182,201.969 63.309,188.946 50.788,201.969 37.916,188.934 25.395,201.969 12.697,188.946 0.001,201.969 V0 H101.575 Z`,
      },
      {
        fill: "#63BF8B",
        id: "ribbon8-2",
        d: `M25.307,175.921 L12.697,188.946 25.395,201.969 37.916,188.934 Z`,
      },
      {
        fill: "#63BF8B",
        id: "ribbon8-3",
        d: `M76.016,175.921 L63.309,188.946 76.2,201.969 88.721,188.934 Z`,
      },
    ],
    palette: [
      ["#A1D296", "#63BF8B", "#63BF8B"],
      ["#3498DB", "#2ECC71", "#F1C40F"],
      ["#8E44AD", "#1ABC9C", "#D35400"],
      ["#E67E22", "#16A085", "#2980B9"],
    ],
  },
  {
    id: "ribbon9",
    viewBox: "0 0 101.575 201.97",
    selectedpalate: 0,
    data: [
      {
        fill: "#63C08C",
        id: "ribbon9-1",
        d: `M50.787,178.099c20.419,0,38.669,9.29,50.756,23.87h0.031V0.001H0v201.968h0.031
      C12.119,187.389,30.367,178.099,50.787,178.099z`,
      },
      {
        fill: "#A2D397",
        id: "ribbon9-2",
        d: `M11.355,0.001V179.66c10.998-8.155,24.638-12.912,39.432-12.912c14.796,0,28.437,4.757,39.435,12.914V0.001
      H11.355z`,
      },
    ],
    palette: [
      ["#63C08C", "#A2D397"],
      ["#3498DB", "#2ECC71"],
      ["#8E44AD", "#1ABC9C"],
      ["#D35400", "#2C3E50"],
    ],
  },

  {
    id: "ribbon10",
    viewBox: "0 0 100 40.3",
    selectedpalate: 0,
    data: [
      {
        fill: "#105C8F",
        id: "ribbon10-1",
        d: `M86.4,19.5 L99.4,19.4 91.4,28.9 96.5,39.4 79.4,39.8 84.7,31.6 Z`,
      },
      {
        fill: "#0B3B56",
        id: "ribbon10-2",
        d: `M80.2,31.5 L84.8,31.5 79.4,39.8 Z`,
      },
      {
        fill: "#105C8F",
        id: "ribbon10-3",
        d: `M2.8,0.6 L16.5,1 12.3,7.1 10.9,17.3 0.7,17.2 7.3,8.9 Z`,
      },
      {
        fill: "#0B3B56",
        id: "ribbon10-4",
        d: `M16.5,1 L12.2,7.2 15.6,7.2 Z`,
      },
      {
        fill: "#3582C4",
        id: "ribbon10-5",
        d: `M12.3,7.2 L88.2,7.3 84.8,31.5 8.8,31.9 Z`,
      },
    ],
    palette: [
      ["#105C8F", "#0B3B56", "#105C8F", "#0B3B56", "#3582C4"],
      ["#3498DB", "#2ECC71", "#F1C40F", "#E74C3C", "#9B59B6"],
      ["#8E44AD", "#1ABC9C", "#D35400", "#2C3E50", "#27AE60"],
      ["#E67E22", "#16A085", "#2980B9", "#F39C12", "#34495E"],
    ],
  },
  {
    id: "ribbon11",
    viewBox: "0 0 101.575 201.971",
    selectedpalate: 0,
    data: [
      {
        fill: "#63BF8B",
        id: "ribbon11-1",
        d: `M0,-0.144 V201.969 L36.292,179.194 36.36,-0.163 Z`,
      },
      {
        fill: "#A1D296",
        id: "ribbon11-2",
        d: `M65.217,179.126 L50.694,170.157 36.292,179.194 36.36,-0.163 H65.216 Z`,
      },
      {
        fill: "#63BF8B",
        id: "ribbon11-3",
        d: `M101.575,168.468 V-0.163 H65.216 V179.126 L101.575,201.97 Z`,
      },
    ],
    palette: [
      ["#63BF8B", "#A1D296", "#63BF8B"],
      ["#3498DB", "#2ECC71", "#F1C40F"],
      ["#8E44AD", "#1ABC9C", "#D35400"],
      ["#E67E22", "#16A085", "#2980B9"],
    ],
  },
  {
    id: "ribbon12",
    viewBox: "0 0 400 200",

    selectedpalate: 0,
    data: [
      {
        fill: "#F8F096",
        id: "ribbon12-1",
        d: `M328.1,59.8v46.9c-21.2,20.9-34.8,24.6-61.9,27.8c-25.1,2.9-83.3-13.5-124.7-13.5c-5.9,0-11.4,0.5-16.6,1.5
      C93.6,128.1,75.7,148,75.7,148v-47c0,0,24.4-27,65.8-27s99.7,16.4,124.7,13.5c8.3-1,15.4-2,21.8-3.6
      C302.4,80.5,313.5,74.3,328.1,59.8z`,
      },
      {
        fill: "#D8C86B",
        id: "ribbon12-2",
        d: `M124.9,122.4l-9.1,41.9c-12.9-9.7-40.1-16.4-40.1-16.4S93.7,128.1,124.9,122.4z M328.1,59.8
      C313.4,74.3,302.4,80.5,288,84l-8.6-39.3C286.7,51.2,328.1,59.8,328.1,59.8z`,
      },
      {
        fill: "#EDDE72",
        id: "ribbon12-3",
        d: `M115.9,164.3c-57.8-18.1-107.8,0-107.8,0l19.8-28.2L0,118.9c0,0,22.8-10.7,75.7-8.5V148
      C75.7,147.9,103,154.6,115.9,164.3z M373.4,61.8l17.1,27.7c-14.9-8.4-62.4-6.2-62.4-6.2V59.8c0,0-41.4-8.6-48.7-15.1
      c0-0.4,51.5-20.1,120.6,0L373.4,61.8z`,
      },
    ],
    palette: [
      ["#F8F096", "#D8C86B", "#EDDE72"],
      ["#1F618D", "#5DADE2", "#D4E6F1"],
      ["#196F3D", "#52BE80", "#ABEBC6"],
      ["#7D6608", "#F4D03F", "#F9E79F"],
    ],
  },
  {
    id: "ribbon13",
    viewBox: "0 0 400 100",

    selectedpalate: 0,
    data: [
      {
        fill: "#7D529A",
        id: "ribbon13-1",
        d: `M319,62.9c-0.6-4-4.9-7.7-14.8-8.3c-9.5-0.6-22.9,0.8-38.5,3.2c-22.1,3.4-48.6,8.7-75,13.3
      c-39.9,6.9-75,14.4-95.6,7.9c-12.6-3.9-13-9.8-13-9.8L82,42.7V32.2c0.1,0.6,0.2,1.1,0.3,1.7c1.3,4.3,8.5,12.9,51.4,6.5
      c5.8-0.9,12.3-2.1,19.6-3.5c60.4-12.5,141.2-23.2,158.1-15.4c7.3,3.4,7.2,9.3,7.2,9.3l0.4,25.7L319,62.9z`,
      },
      {
        fill: "#825EA1",
        id: "ribbon13-2",
        d: `M134.3,23.7L134.3,23.7c-0.4,4.4-5.2,7.9-23.1,3.3c-25.6-6.6-29.7,0.2-29.2,5.2v10.5
      c-30.6-2.9-69.8,13.7-69.8,13.7l15.2-22.5L0,25.6C0,25.6,42.2,9.2,78.1,8c36-1.2,51.3,4.6,54,8.8C133.2,18.3,134.5,21.2,134.3,23.7z
       M400,72.4c0,0-35.2,19.4-77,19.8c-41.8,0.4-51.9-6.8-54.8-9.9c-1.6-1.6-2.8-4.1-2.6-6.5l0,0c0.2-2.1,1.5-4,4.7-5.3
      c6.7-2.6,22.1-0.3,34,2.7c7.7,1.9,14.2-3.1,14.8-8.4c0.1-0.6,0.1-1.3,0-1.9l-0.1-6.5c0,0,45.1,1.8,67.1-14.7l-13.3,22.9L400,72.4z`,
      },
      {
        fill: "#5A4277",
        id: "ribbon13-3",
        d: `M134.3,23.8l-0.6,16.6c-42.9,6.5-50.1-2.2-51.4-6.5c-0.2-0.5-0.3-1.1-0.3-1.7c-0.5-5,3.6-11.8,29.2-5.2
      C129.1,31.6,133.8,28.1,134.3,23.8z M319.1,64.8c-0.6,5.3-7.1,10.3-14.8,8.4c-11.9-3-27.3-5.4-34-2.7c-3.2,1.3-4.5,3.2-4.7,5.3
      l0.3-18c15.6-2.4,29-3.8,38.5-3.2c9.9,0.6,14.1,4.3,14.8,8.3L319.1,64.8z`,
      },
    ],
    palette: [
      ["#7D529A", "#825EA1", "#5A4277"],
      ["#1F618D", "#5DADE2", "#D4E6F1"],
      ["#196F3D", "#52BE80", "#ABEBC6"],
      ["#7D6608", "#F4D03F", "#F9E79F"],
    ],
  },
  {
    id: "ribbon14",
    viewBox: "0 0 400 100",

    selectedpalate: 0,
    data: [
      {
        fill: "#F8F096",
        id: "ribbon14-1",
        d: `M322.8,11.4v43.5c-4.9-0.4-9.7-0.8-14.6-1.1C272.4,51.3,236.4,50,200,50s-72.4,1.3-108.2,3.8
      c-4.9,0.4-9.8,0.7-14.6,1.1V11.4c40.5-3.2,81.4-4.9,122.8-4.9S282.3,8.2,322.8,11.4z`,
      },
      {
        fill: "#FFFFFF",
        id: "ribbon14-2",
        d: `M84.6,16.5c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9c0,0.5-0.3,0.9-0.9,0.9C85,17.4,84.6,17.1,84.6,16.5z
       M93,15.9c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9c0,0.5-0.3,0.9-0.9,0.9S93,16.5,93,15.9z M101.3,15.4c0-0.5,0.4-0.9,0.9-0.9
      s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9C101.7,16.3,101.3,15.9,101.3,15.4z M109.7,14.9c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9
      s-0.3,0.9-0.9,0.9C110,15.8,109.7,15.4,109.7,14.9z M118,14.4c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9
      C118.4,15.3,118,14.9,118,14.4z M126.4,14c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9S126.4,14.5,126.4,14z
       M134.7,13.6c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9C135.1,14.5,134.7,14.1,134.7,13.6z M143.1,13.3
      c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9C143.5,14.1,143.1,13.8,143.1,13.3z M151.5,13c0-0.5,0.4-0.9,0.9-0.9
      s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9S151.5,13.5,151.5,13z M159.8,12.7c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9
      C160.2,13.6,159.8,13.2,159.8,12.7z M168.2,12.5c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9S168.2,13,168.2,12.5z
       M176.6,12.4c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9C176.9,13.3,176.6,12.9,176.6,12.4z M184.9,12.3
      c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9C185.3,13.2,184.9,12.8,184.9,12.3z M193.3,12.2c0-0.5,0.4-0.9,0.9-0.9
      s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9C193.6,13.1,193.3,12.7,193.3,12.2z M201.7,12.2c0-0.5,0.4-0.9,0.9-0.9s0.8,0.4,0.9,0.9
      c0,0.5-0.3,0.9-0.9,0.9C202,13.1,201.7,12.7,201.7,12.2z M210,12.2c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9
      C210.4,13.1,210,12.7,210,12.2z M218.4,12.3c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9S218.4,12.8,218.4,12.3z
       M226.8,12.4c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9C227.1,13.3,226.8,12.9,226.8,12.4z M235.1,12.6
      c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9C235.5,13.5,235.1,13.1,235.1,12.6z M243.5,12.8c0-0.5,0.4-0.9,0.9-0.9
      s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9S243.5,13.3,243.5,12.8z M251.8,13c0-0.5,0.4-0.9,0.9-0.9s0.8,0.4,0.9,0.9c0,0.5-0.3,0.9-0.9,0.9
      C252.2,13.9,251.8,13.6,251.8,13z M260.2,13.3c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9
      C260.6,14.2,260.2,13.9,260.2,13.3z M268.6,13.7c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9
      C268.9,14.6,268.6,14.2,268.6,13.7z M276.9,14.1c0-0.5,0.4-0.9,0.9-0.9s0.8,0.4,0.9,0.9c0,0.5-0.3,0.9-0.9,0.9
      C277.3,15,276.9,14.6,276.9,14.1z M285.3,14.5c0-0.5,0.4-0.9,0.9-0.9s0.8,0.4,0.9,0.9c0,0.5-0.3,0.9-0.9,0.9
      C285.6,15.4,285.3,15,285.3,14.5z M293.6,15c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9C294,15.9,293.6,15.5,293.6,15z
       M302,15.5c0-0.5,0.4-0.9,0.9-0.9s0.8,0.4,0.9,0.9c0,0.5-0.3,0.9-0.9,0.9S302,16,302,15.5z M310.3,16.1c0-0.5,0.4-0.9,0.9-0.9
      s0.9,0.4,0.9,0.9c0,0.5-0.3,0.9-0.9,0.9C310.7,17,310.3,16.6,310.3,16.1z M318.7,16.7c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9
      s-0.3,0.9-0.9,0.9S318.7,17.2,318.7,16.7z M84.6,48.6c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9
      C85,49.4,84.6,49.1,84.6,48.6z M93,48c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9C93.3,48.8,93,48.5,93,48z
       M101.3,47.4c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9C101.7,48.3,101.3,47.9,101.3,47.4z M109.7,46.9
      c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9C110,47.8,109.7,47.4,109.7,46.9z M118,46.4c0-0.5,0.4-0.9,0.9-0.9
      s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9C118.4,47.3,118,46.9,118,46.4z M126.4,46c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9
      s-0.3,0.9-0.9,0.9S126.4,46.5,126.4,46z M134.7,45.6c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9
      C135.1,46.5,134.7,46.1,134.7,45.6z M143.1,45.3c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9
      C143.5,46.2,143.1,45.8,143.1,45.3z M151.5,45c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9S151.5,45.5,151.5,45z
       M159.8,44.7c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9C160.2,45.6,159.8,45.2,159.8,44.7z M168.2,44.5
      c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9S168.2,45,168.2,44.5z M176.6,44.4c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9
      s-0.3,0.9-0.9,0.9C176.9,45.3,176.6,44.9,176.6,44.4z M184.9,44.3c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9
      C185.3,45.2,184.9,44.8,184.9,44.3z M193.3,44.2c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9
      C193.6,45.1,193.3,44.7,193.3,44.2z M201.7,44.2c0-0.5,0.4-0.9,0.9-0.9s0.8,0.4,0.9,0.9c0,0.5-0.3,0.9-0.9,0.9
      C202,45.1,201.7,44.7,201.7,44.2z M210,44.2c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9C210.4,45.1,210,44.7,210,44.2z
       M218.4,44.3c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9S218.4,44.8,218.4,44.3z M226.8,44.4c0-0.5,0.4-0.9,0.9-0.9
      s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9C227.1,45.3,226.8,44.9,226.8,44.4z M235.1,44.6c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9
      s-0.3,0.9-0.9,0.9C235.5,45.5,235.1,45.1,235.1,44.6z M243.5,44.8c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9
      S243.5,45.3,243.5,44.8z M251.8,45c0-0.5,0.4-0.9,0.9-0.9s0.8,0.4,0.9,0.9c0,0.5-0.3,0.9-0.9,0.9C252.2,45.9,251.8,45.6,251.8,45z
       M260.2,45.4c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9C260.6,46.2,260.2,45.9,260.2,45.4z M268.6,45.7
      c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9C268.9,46.6,268.6,46.2,268.6,45.7z M276.9,46.1c0-0.5,0.4-0.9,0.9-0.9
      s0.8,0.4,0.9,0.9c0,0.5-0.3,0.9-0.9,0.9C277.3,47,276.9,46.6,276.9,46.1z M285.3,46.5c0-0.5,0.4-0.9,0.9-0.9s0.8,0.4,0.9,0.9
      c0,0.5-0.3,0.9-0.9,0.9C285.6,47.4,285.3,47,285.3,46.5z M293.6,47c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9
      C294,47.9,293.6,47.5,293.6,47z M302,47.5c0-0.5,0.4-0.9,0.9-0.9s0.8,0.4,0.9,0.9c0,0.5-0.3,0.9-0.9,0.9S302,48.1,302,47.5z
       M310.3,48.1c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9C310.7,49,310.3,48.6,310.3,48.1z M318.7,48.7
      c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9s-0.3,0.9-0.9,0.9C319,49.6,318.7,49.2,318.7,48.7z`,
      },
      {
        fill: "#F2E77E",
        id: "ribbon14-3",
        d: `M91.9,76.2c-4.9,0.4-9.8,0.8-14.6,1.2C68,78.1,58.8,79,49.6,80V42.6c9.2-0.9,18.4-1.8,27.6-2.6v14.9L91.9,76.2z
       M350.4,42.6V80c-9.2-1-18.4-1.8-27.6-2.6c-4.9-0.4-9.8-0.8-14.6-1.2l14.6-21.3V40C332,40.8,341.2,41.7,350.4,42.6z`,
      },
      {
        fill: "#EDDE72",
        id: "ribbon14-4",
        d: `M0,93.5l24.1-22.1L0,56.7c16.5-2.3,33-4.2,49.6-5.9V80l27.6,4.9C51.3,87.1,25.5,89.9,0,93.5z M375.9,71.3
      L400,93.5c-25.5-3.5-51.3-6.4-77.2-8.6l27.6-4.9V50.7c16.6,1.7,33.1,3.7,49.6,5.9L375.9,71.3z`,
      },
      {
        fill: "#D5C56B",
        id: "ribbon14-5",
        d: `M91.9,76.2L77.2,54.9c4.9-0.4,9.7-0.8,14.6-1.1L91.9,76.2z M77.2,77.4v7.5L49.6,80C58.8,79,68,78.1,77.2,77.4z
       M322.8,54.9l-14.6,21.3V53.8C313,54.1,317.9,54.5,322.8,54.9z M350.4,80l-27.6,4.9v-7.5C332,78.1,341.2,79,350.4,80z`,
      },
    ],
    palette: [
      ["#F8F096", "#FFFFFF", "#F2E77E", "#EDDE72", "#D5C56B"],
      ["#1B998B", "#E84855", "#FDC500", "#2E294E", "#F7F7F2"],
      ["#6A0572", "#AB83A1", "#FFA400", "#025951", "#03A678"],
      ["#14213D", "#FCA311", "#E5E5E5", "#8D99AE", "#EF233C"],
    ],
  },
  {
    id: "ribbon15",
    viewBox: "0 0 200 400",

    selectedpalate: 0,
    data: [
      {
        fill: "#5A61A7",
        id: "ribbon15-1",
        d: `M174.2,49.7 V347.8 L100,289.8 L25.8,347.8 V49.7 Z`,
      },
      {
        fill: "#A4ACD6",
        id: "ribbon15-2",
        d: `M176.5,352.6L100,292.7l-76.5,59.9V47.4h153V352.6z M100,286.8l71.8,56.2V52H28.2v291L100,286.8z`,
      },
    ],
    palette: [
      ["#5A61A7", "#A4ACD6"],
      ["#1B998B", "#E84855"],
      ["#6A0572", "#AB83A1"],
      ["#14213D", "#FCA311"],
    ],
  },
  {
    id: "ribbon16",
    viewBox: "0 0 400 100",

    selectedpalate: 0,
    data: [
      {
        fill: "#5A61A7",
        id: "ribbon16-1",
        d: `M103.6,37.3c-12.2,0.5-24.3,1-36.5,1.6c0-3.6,1.9-6.7,4.8-8.3l20.2-12.2c1.4-0.8,2.5-2,3.2-3.4
      c0.7-1.2,1-2.7,1.1-4.2c0-0.1,0-0.3,0-0.4L103.6,37.3z M333,37.8c-12.2-0.5-24.4-0.9-36.6-1.3l0.1-0.4l7.2-26.2
      c0,3.3,1.6,6.2,4.3,7.7l0,0l20.2,11.9C331.1,31.2,333,34.3,333,37.8z`,
      },
      {
        fill: "#A4ACD6",
        id: "ribbon16-2",
        d: `M333,37.8l-7.9,24.8l-8.4,26.7c-34.6-1.2-69.5-1.8-104.4-1.8c-43.2,0-86.2,0.9-128.9,2.8L75,63.8l-7.9-24.9l0,0
      c12.1-0.6,24.3-1.1,36.5-1.6c36.1-1.3,72.3-2,108.7-2c28.1,0,56.2,0.4,84.1,1.2C308.6,36.8,320.8,37.3,333,37.8z M96.4,10.9
      c-0.1,1.5-0.5,2.9-1.1,4.1c-0.7,1.4-1.8,2.4-3.2,3.3L71.9,30.6c-2.8,1.6-4.8,4.4-4.8,7.9v0.4L75,63.5c-24.9,1-49.6,2.4-74.3,4.1l0,0
      l28.5-27L0.7,15.3c0.1,0,0.2,0,0.4,0c1.8-0.1,3.6-0.2,5.4-0.4c4.1-0.3,8.2-0.5,12.3-0.8c2.9-0.2,5.7-0.3,8.6-0.5
      c7-0.4,14-0.8,20.9-1.1c15.7-0.8,31.5-1.5,47.3-2c0.2,0,0.4,0,0.6,0v0.1l0,0L96.4,10.9z M370.9,39.8l28.5,26.9
      c-24.7-1.7-49.4-3-74.3-4l7.9-24.8c0-3.5-1.9-6.6-4.8-8.2l-20.2-12l0,0c-2.7-1.6-4.3-4.5-4.3-7.7l0,0V9.9c32,1.1,63.9,2.7,95.7,4.9
      L370.9,39.8z`,
      },
      {
        fill: "#CAE3EE",
        id: "ribbon16-3",
        d: `M399.7,66.4l-28-26.4l28-24.7c0.2-0.1,0.3-0.4,0.2-0.6c-0.1-0.2-0.3-0.4-0.5-0.4c-3-0.2-6.1-0.4-9.1-0.6
      c0,0,0-0.1-0.1-0.1c-0.2-0.3-0.6-0.3-0.8-0.1l-0.2,0.1c-28.3-1.8-57-3.3-85.4-4.2c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0
      c-0.3,0-0.5,0.2-0.6,0.4v0.1c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0.1l-7,25.6c-27.6-0.8-55.8-1.2-83.8-1.2c-35.9,0-72.3,0.7-108.3,2
      l-7.1-26.4c-0.1-0.3-0.3-0.4-0.6-0.4c-0.1,0-0.2,0.1-0.3,0.2h-0.3c-15.5,0.5-31.5,1.2-47.3,2c-7.5,0.3-14.3,0.7-21,1.1
      c-2.9,0.2-5.7,0.3-8.6,0.5c-4.1,0.3-8.2,0.5-12.3,0.8l-5.8,0.4c-0.2,0-0.4,0.2-0.5,0.4c0,0.2,0,0.4,0.2,0.6l28,24.9L0.3,67.3
      c-0.2,0.1-0.2,0.4-0.1,0.6c0.1,0.2,0.3,0.3,0.5,0.3c24.4-1.7,49.2-3.1,73.8-4.2l8.4,26.4c0,0.2,0.3,0.4,0.5,0.4
      c42.7-1.9,86-2.8,128.9-2.8c34.7,0,69.8,0.6,104.3,1.7c0.3,0,0.5-0.2,0.6-0.4l8.3-26.1c24.6,1,49.5,2.4,73.9,4
      c0.3,0,0.5-0.1,0.4-0.2C399.9,66.8,399.9,66.6,399.7,66.4z M307.7,18.3h0.1l20.1,11.9c2.5,1.4,4.2,4,4.4,6.9
      c-12.4-0.6-23.9-1-35.2-1.3l6.3-23C304.1,15.1,305.6,17.1,307.7,18.3z M92.4,18.9c1.5-0.9,2.6-2,3.4-3.5c0.4-0.7,0.6-1.4,0.8-2.1
      l6.3,23.3c-12.1,0.5-24,1-35.2,1.5c0-0.1,0-0.1,0-0.2c0.3-2.9,1.9-5.5,4.5-7L92.4,18.9z M18.9,14.6c2.8-0.2,5.7-0.3,8.6-0.5
      c6.6-0.3,13.5-0.7,20.9-1.1c15.8-0.8,31.7-1.5,47.3-2h0.1c0,1.3-0.4,2.6-1,3.7c-0.7,1.3-1.7,2.3-3,3.1L71.6,30
      c-3.2,1.8-5.1,4.9-5.1,8.4v0.4c0,0.1,0,0.1,0,0.2l7.7,24c-21.5,0.9-43.1,2-64.5,3.4l28.1-26c0.1,0,0.2-0.1,0.3-0.2
      c0.2-0.2,0.1-0.6-0.1-0.8L9.9,15.2C12.9,15,15.9,14.7,18.9,14.6z M2.1,15.8l4.5-0.4c0.5,0,1.1-0.1,1.6-0.1c0,0,0,0,0,0l28.6,24.6
      L8.1,66.4c0,0-0.1,0.1-0.1,0.1c-1.9,0.1-3.9,0.2-5.8,0.4L29.6,41c0.1-0.1,0.2-0.2,0.2-0.4c0-0.1-0.1-0.3-0.2-0.4L2.1,15.8z
       M316.3,88.6c-34.4-1.2-69.4-1.8-104-1.8c-42.7,0-86,1-128.5,2.8l-8.2-25.9c0.1-0.1,0.1-0.2,0-0.4l-7.7-23.9
      c11.4-0.6,23.4-1.1,35.8-1.6c36.1-1.3,72.7-2,108.7-2c28.1,0,56.3,0.4,84,1.2c0,0,0,0,0,0c11.5,0.4,23.1,0.8,35.9,1.3l-5,15.7
      L316.3,88.6z M333.4,38.3C333.4,38.3,333.4,38.3,333.4,38.3c0.1-0.1,0.2-0.2,0.2-0.4c0-1.4-0.3-2.8-0.9-4.1c-0.9-2-2.4-3.8-4.3-4.8
      l-20.2-11.9h-0.1c-0.3-0.1-0.5-0.3-0.7-0.5c-1.8-1.5-2.9-3.7-3-6.2c28,0.9,56.1,2.3,83.9,4.1l-28,24c0,0-0.1,0.1-0.1,0.1
      c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0.2,0,0.4,0.1,0.5l28.1,26
      c-20.7-1.3-41.7-2.4-62.4-3.3L333.4,38.3z M390.1,65.5L361.4,39l28.4-24.4c2.7,0.2,5.4,0.3,8.1,0.5l-27.4,24.3
      c-0.1,0.1-0.2,0.2-0.2,0.4c0,0.1,0.1,0.3,0.2,0.4L397.9,66C395.3,65.8,392.7,65.7,390.1,65.5z`,
      },
    ],
    palette: [
      ["#5A61A7", "#A4ACD6", "#CAE3EE"],
      ["#1F618D", "#5DADE2", "#D4E6F1"],
      ["#196F3D", "#52BE80", "#ABEBC6"],
      ["#7D6608", "#F4D03F", "#F9E79F"],
    ],
  },
  {
    id: "ribbon17",
    viewBox: "0 0 200 400",

    selectedpalate: 0,
    data: [
      {
        fill: "#EDDE72",
        id: "ribbon17-1",
        d: `M100,351.4c-3.4,0-6.6-1.1-9.3-3.2c-2.8-2.2-6.6-2.9-10.1-1.6c-1.7,0.6-3.4,0.9-5.2,0.9c-5,0-9.7-2.5-12.5-6.7
      c-1.9-2.9-5.2-4.6-8.6-4.6c-0.3,0-0.4,0-0.5,0c-0.3,0-0.4,0-0.5,0c-6.7,0-12.7-4.5-14.5-11c-0.5-1.7-1.4-3.3-2.7-4.5
      c-1.2-1.3-2.8-2.2-4.5-2.7c-6.5-1.8-11-7.8-11-14.5c0-0.1,0-0.3,0-0.4c0-0.3,0-0.4,0-0.5c0-3.6-1.7-6.9-4.6-8.8
      c-4.2-2.8-6.7-7.5-6.7-12.5c0-1.8,0.3-3.5,0.9-5.2c0.4-1.2,0.6-2.4,0.6-3.6c0-2.3-0.8-4.6-2.2-6.4c-2.1-2.6-3.2-5.9-3.2-9.3V48.6
      h189v208.2c0,3.4-1.1,6.7-3.2,9.3c-1.4,1.8-2.2,4.1-2.2,6.4c0,1.2,0.2,2.5,0.6,3.6c0.6,1.7,0.9,3.4,0.9,5.2c0,5-2.5,9.7-6.7,12.5
      c-2.9,1.9-4.6,5.2-4.6,8.7c0,0.2,0,0.4,0,0.5c0,0.3,0,0.4,0,0.5c0,6.7-4.5,12.6-11,14.5c-1.7,0.5-3.3,1.4-4.5,2.7
      c-1.3,1.3-2.2,2.8-2.7,4.5c-1.8,6.5-7.8,11-14.5,11c-0.1,0-0.2,0-0.4,0c-0.3,0-0.4,0-0.5,0c-3.6,0-6.9,1.7-8.8,4.6
      c-2.8,4.2-7.5,6.7-12.5,6.7c-1.8,0-3.5-0.3-5.2-0.9c-3.5-1.3-7.2-0.6-10.1,1.6C106.6,350.3,103.4,351.4,100,351.4z`,
      },
      {
        fill: "#CE483C",
        id: "ribbon17-2",
        d: `M190,53.3H10.1v203.6c0,2.3,0.8,4.6,2.2,6.5c2.1,2.6,3.2,6,3.2,9.3c0,1.8-0.3,3.5-0.9,5.2
      c-0.4,1.2-0.6,2.4-0.6,3.6c0,3.5,1.7,6.7,4.6,8.6c4.2,2.8,6.7,7.5,6.7,12.5c0,0.1,0,0.2,0,0.4s0,0.4,0,0.5c0,4.8,3.1,8.9,7.6,10.1
      c2.5,0.7,4.8,2,6.6,3.9c1.8,1.8,3.2,4.1,3.8,6.5c1.3,4.5,5.4,7.6,10,7.6c0.3,0,0.4,0,0.5,0c0.3,0,0.4,0,0.5,0c5,0,9.7,2.5,12.5,6.7
      c2.6,3.9,7.7,5.6,12.3,4c1.6-0.7,3.4-1,5.2-1c3.4,0,6.7,1.1,9.3,3.2c3.7,2.9,9.2,2.9,12.9,0c4.1-3.2,9.6-4.1,14.5-2.3
      c4.6,1.7,9.6-0.1,12.3-4c2.8-4.2,7.5-6.7,12.5-6.7c0.1,0,0.3,0,0.4,0c0.3,0,0.4,0,0.5,0c4.8,0,8.9-3.1,10.1-7.6
      c0.7-2.5,2-4.7,3.8-6.5c1.8-1.8,4.1-3.1,6.6-3.9c4.5-1.3,7.6-5.4,7.6-10c0-0.3,0-0.4,0-0.5c0-0.2,0-0.4,0-0.5c0-5,2.5-9.7,6.7-12.5
      c2.9-1.9,4.6-5.2,4.6-8.6c0-1.2-0.2-2.4-0.6-3.6c-0.6-1.7-0.9-3.4-0.9-5.2c0-3.4,1.1-6.7,3.2-9.3c1.4-1.8,2.2-4.1,2.2-6.5V53.3z
       M74.8,320.6l0.6,3.5l-3.2-1.6l-3.1,1.6l0.6-3.5l-2.6-2.5l3.5-0.5l1.6-3.2l1.6,3.2l3.5,0.5L74.8,320.6z M104,324.6l0.9,5.5l-4.9-2.6
      l-4.9,2.6l0.9-5.5l-3.9-3.8l5.5-0.8l2.4-5l2.4,5l5.5,0.8L104,324.6z M130.9,320.6l0.6,3.5l-3.2-1.6l-3.1,1.6l0.6-3.5l-2.6-2.5
      l3.6-0.5l1.5-3.2l1.6,3.2l3.5,0.5L130.9,320.6z`,
      },
    ],
    palette: [
      ["#EDDE72", "#CE483C"],
      ["#3498DB", "#2ECC71"],
      ["#8E44AD", "#1ABC9C"],
      ["#D35400", "#2C3E50"],
    ],
  },
]
